import React from 'react'
import { Breadcrumb, BreadcrumbItem, Container, Row, Col, Label, Button } from 'reactstrap'
import { Quote } from '../model/Quote'
import { getQuote, updateIsShipped } from '../model/request/quotes'
import DateTextField from '../view/DateTextField'

class JobViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            quote: null,
        }
    }

    componentDidMount() {
        getQuote(this.props.id)
        .then(
            (result) => {
                this.setState({
                    quote: Quote.from(result.data.quote)
                })
            },
            (error) => {
                this.props.showError(error)
            }
        )
    }

    updateQuote() {
        this.props.turnOnLoader()
        updateIsShipped(this.state.quote.id,
            this.state.quote.is_shipped,
            this.state.quote.shipped_date).then(
            (result) => {
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    // On Click Stage

    onClickStage1() {
        this.props.viewQuote(this.state.quote.id)
    }

    onClickStage2() {
        this.props.viewBacklog(this.state.quote.id)
    }

    onClickStage3() {
        this.props.viewScheduler(this.state.quote.id)
    }

    onClickStage4() { 
        this.props.viewFiles(this.state.quote.id)
    }

    onClickStage5() { }

    // MARK: render

    render() {
        if (!this.state.quote) {
            return <Container />
        }

        return (
            <Container style={{'paddingTop': '38px'}}>
                <Row>
                    <Col>
                        <Breadcrumb tag="nav" listTag="div">
                            <BreadcrumbItem tag="a" href="/quotes">Jobs</BreadcrumbItem>
                            <BreadcrumbItem active tag="span">Job</BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Label text={this.state.quote.job_name}>{this.state.quote.job_name}</Label>
                    </Col>
                    <Col>
                        <Label>{this.state.quote.customer_name}</Label>
                    </Col>
                </Row>
                <Row onClick={(e) => {this.onClickStage1()}} >
                    <Col><Label><b>Stage 1:</b> Quote</Label></Col>
                    <Col><i className="fa fa-fw fa-check"></i></Col>
                </Row>
                <Row onClick={(e) => this.onClickStage2()} >
                    <Col><Label><b>Stage 2:</b> Backlog</Label></Col>
                    <Col><i className="fa fa-fw fa-check"></i></Col>
                </Row>
                <Row onClick={(e) => this.onClickStage3()} >
                    <Col><Label><b>Stage 3:</b> Scheduler</Label></Col>
                    <Col><i className="fa fa-fw fa-check"></i></Col>
                </Row>
                <Row onClick={(e) => this.onClickStage4()} >
                    <Col><Label><b>Stage 4:</b> Files</Label></Col>
                    <Col><i className="fa fa-fw fa-check"></i></Col>
                </Row>
                <Row style={{
                    'marginBottom': '20px',
                }}>
                    <Col><Label><b>Stage 5:</b> Shipped</Label></Col>
                    <Col>
                        <input type='checkbox' checked={this.state.quote.is_shipped}
                            onClick={(e) => {
                                const q = this.state.quote
                                q.is_shipped = !q.is_shipped

                                this.setState({
                                    'quote': q,
                                })
                            }} />
                        <div style={{
                            'display': 'inline-block',
                            'width': 'min(600px, 100% - 22px)',
                            'marginLeft': '8px',
                            'maxWidth': '200px',
                        }}>
                            <DateTextField style={{
                                    'display': 'inline-block',
                                }}
                                value={
                                    this.state.quote.shipped_date ? 
                                    this.state.quote.shipped_date :
                                    undefined
                                }
                                showModal={this.props.showModal}
                                closeModal={this.props.closeModal}
                                onChange={(date) => {
                                    const q = this.state.quote
                                    q.shipped_date = date

                                    this.setState({
                                        'quote': q
                                    })
                                }}
                                />
                        </div>
                        <Button
                            color='success'
                            onClick={(e) => {
                            this.updateQuote()
                        }}> Save</Button>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default JobViewController
